// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Date formatting utilities
 */

// Format UTC time to Eastern Time
export function formatToEastern(dateStr: string): string {
  // The backend sends ISO format with timezone (e.g., 2025-05-22T23:53:31.268725+00:00)
  // No need to append 'Z' as the timezone is already included
  const date = new Date(dateStr)
  
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    console.error('Invalid date string:', dateStr)
    return 'Invalid Date'
  }
  
  return date.toLocaleString('en-US', { 
    timeZone: 'America/New_York',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true
  })
}